/**
 * Created by asiulik on 29.11.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', './filterConfig'], function($, _, EventEmitter, FilterConfig){

    function FilterHeader($filterHeader) {

        this.$filterHeader = $filterHeader;

    }

    FilterHeader.prototype = _.clone(EventEmitter.prototype);

    FilterHeader.prototype.init = function(){

        this.$filterItems =
            this.$filterHeader.find(FilterConfig.filterHeaderItemSelector);

        this.$mobileHeader = this.$filterHeader.find('.filter__mobile__selected');
        this.$headerBox = this.$filterHeader.find('.filter__header__box');

        // this.$mobileHeader.text(
        //     $(this.getCurrentActiveElement()).text()
        // );

        this.bindEvents();

    };

    FilterHeader.prototype.bindEvents = function(){

        var _this = this;

        this.$filterItems.on({
            click: function(e){

                e.preventDefault();

                if(_this.disabledState) return;

                var $this = $(this);
                var tagValue = $this.attr(FilterConfig.filterHeaderItemTagAttr);

                _this.emit('filter:header:tagChange', tagValue, $this.attr('href'));
                _this.toogleButtonActiveClass($this);

                _this.toggleMobileBox();

            }
        })

        this.$mobileHeader.on({
            click: function(e){

                e.preventDefault();
                _this.toggleMobileBox();

            }
        })

    };

    FilterHeader.prototype.toggleMobileBox = function(){
        this.$headerBox.toggleClass('filter__header__box--active');
    };

    FilterHeader.prototype.toogleButtonActiveClass = function($element){

        this.$filterItems.removeClass(FilterConfig.filterHeaderItemActiveClass);
        $element.addClass(FilterConfig.filterHeaderItemActiveClass);

        this.$mobileHeader.find('.filter__mobile__selected__value').text($element.text());

    };

    FilterHeader.prototype.getCurrentActiveElement = function(){
        return this.$filterItems.filter(function(index, item) {
            return $(item).hasClass(FilterConfig.filterHeaderItemActiveClass);
        })[0];
    };

    FilterHeader.prototype.setDisabledState = function(value) {
        this.disabledState = !!value;
    };



    return FilterHeader;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/filters/filterHeader.js